import React from 'react';

/**
 * First focusable control for keyboard / screen reader users — jumps past the nav chrome.
 */
const SkipToMainContent: React.FC = () => (
  <a href="#main-content" className="skip-to-main">
    Skip to main content
  </a>
);

export default SkipToMainContent;
